import { createContext, ReactChild, useContext } from 'react';

interface UserStateProviderProps {
  children: ReactChild | ReactChild[];
  userState: User;
  handleUpdateUserStatus: (employeeId: string, status: string) => void;
  setOfflineDialogOpen: (open: boolean) => void;
}

interface IUserStateContext {
  userState: User;
  handleUpdateUserStatus: (employeeId: string, status: string) => void;
  setOfflineDialogOpen: (open: boolean) => void;
}

const UserStateContext = createContext<IUserStateContext | null>(null);

function UserStateProvider({
  children,
  userState,
  handleUpdateUserStatus,
  setOfflineDialogOpen,
}: UserStateProviderProps): JSX.Element {
  return (
    <UserStateContext.Provider value={{ userState, handleUpdateUserStatus, setOfflineDialogOpen }}>
      {children}
    </UserStateContext.Provider>
  );
}

function useUserState(): IUserStateContext {
  const userStateContext = useContext(UserStateContext);

  if (!userStateContext) {
    throw new Error('useUserState must be used within a UserStateProvider');
  }

  return userStateContext;
}

export { UserStateProvider, useUserState };
